export enum DocStatusDto {
  Created = 0,
  NotCreated = 1,
  OlderVersion = 2,
}
